<template>
    <div>
        <div class="search">
            <a-form-model layout="inline" :model="searchForm">
                <a-form-model-item label="学生姓名">
                    <a-input :maxLength="30" allowClear class="serach-item" v-model="searchForm.userName" placeholder="请输入学生姓名"/>
                </a-form-model-item>
                <a-form-model-item label="所在年级">
                    <a-select class="serach-item" allowClear @change="getClassList" v-model="searchForm.gradeId"
                              placeholder="请选择年级">
                        <a-select-option :value="item.id" v-for="item in gradeList" :key="item.id">
                            {{item.name}}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item label="所在班级">
                    <a-select class="serach-item" allowClear v-model="searchForm.classId" placeholder="请选择班级">
                        <a-select-option :value="item.id" v-for="item in classList">
                            {{item.name}}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item label="完成状态" ref="progress">
                    <a-select class="serach-item" allowClear v-model="searchForm.statuss" placeholder="请选择完成状态">
                        <a-select-option :value="0">未完成</a-select-option>
                        <a-select-option :value="1">进行中</a-select-option>
                        <a-select-option :value="2">已完成</a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item>
                    <a-button @click="getPageList(1)" type="primary" html-type="button">
                        查询
                    </a-button>
                    <a-button @click="searchReset" style="margin-left: 10px;">
                        重置
                    </a-button>
                </a-form-model-item>
            </a-form-model>
        </div>
        <a-table style="min-width: 800px;"
                 :columns="columns"
                 :rowKey="(text, index) => JSON.stringify(text)"
                 :pagination="{...tableRelevant.tablePagination, pageSizeOptions: ['10', '50', '100', '500', '1000']}"
                 :scroll="{y: 300}"
                 :row-selection="rowSelection"
                 :locale="tableRelevant.locale"
                 :loading="tableRelevant.tableLoading"
                 :dataSource="tableRelevant.tableDataSource">
            <span slot="gender" slot-scope="text">
                {{ text === 1 ? "男" : "女"}}
            </span>
            <div slot="birthday" slot-scope="text">
                {{ text ? text.split(" ")[0] : ""}}
            </div>
            <span slot="progress" slot-scope="text, record">
                <a-progress :percent="text" size="small"/>
            </span>
        </a-table>
    </div>
</template>

<script>
    import {tableRelevant} from "@/pages/projectImpl/js/utils";

    const columns = [
        {
            title: '姓名',
            dataIndex: 'realName'
        },
        {
            title: '性别',
            dataIndex: 'gender',
            scopedSlots: {customRender: 'gender'}
        },
        {
            title: '学校/机构',
            dataIndex: 'organizationName',
            ellipsis: true
        },
        {
            title: '年级',
            dataIndex: 'gradeName'
        },
        {
            title: '班级',
            dataIndex: 'className'
        },
        {
            title: '出生日期',
            dataIndex: 'birthday',
            scopedSlots: {customRender: 'birthday'}
        },
        {
            title: '进行状态',
            dataIndex: 'progress',
            scopedSlots: {customRender: 'progress'}
        },
    ];
    export default {
        name: "StepsSecondAddStudents",
        props: {
            nowCourseInfo: {},
            IsDetails: false,
        },
        data() {
            return {
                columns,
                gradeList: [],
                classList: [],
                searchForm: {
                    gradeId: undefined,
                    classId: undefined,
                    statuss: undefined,
                    Enabled: 1,
                    userName: undefined
                },
                //当前报告信息
                reportInfo: this.$store.getters['organization/getReportInfo'],
                //表格相关
                tableRelevant: tableRelevant.call(this),
                //表格选中项
                tableSelected: {
                    selectedRowKeys: []
                }
            }
        },
        computed: {
            rowSelection() {
                return {
                    selections: false,
                    selectedRowKeys: this.tableSelected.selectedRowKeys,
                    onChange: selectedRowKeys => {
                        this.tableSelected.selectedRowKeys = selectedRowKeys;
                    },
                    getCheckboxProps: record => ({
                        props: {
                            disabled: this.IsDetails
                        },
                    }),
                };
            }
        },
        mounted() {
            this.getPageList();
            this.getGradeList();
        },
        methods: {
            //获取学生列表
            getPageList(pageIndex) {
                if (pageIndex) {
                    this.tableRelevant.tablePagination.current = pageIndex;
                }
                const params = {
                    // organizationId: this.nowCourseInfo.reportCourse.organizationId,
                    // projectCourseConfigId: this.nowCourseInfo.reportCourse.projectCourseConfigId,
                    "Parameter.ProjectCourseChildId":  this.nowCourseInfo.reportCourse.projectCourseChildId || this.nowCourseInfo.projectCourseChildId,
                    "Parameter.GroupReportId": this.reportInfo.id,
                    "Parameter.GroupReportCourseId": this.nowCourseInfo.reportCourse.id,
                    "Parameter.OrganizationId": this.nowCourseInfo.reportCourse.organizationId,
                    "Parameter.GradeId": this.searchForm.gradeId,
                    "Parameter.ClassId": this.searchForm.classId,
                    "Parameter.UserName": this.searchForm.userName,
                    "Parameter.Statuss": this.searchForm.statuss,
                    pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
                    pageSize: this.tableRelevant.tablePagination.pageSize,
                    // ...this.searchForm
                };
                this.tableRelevant.tableLoading = true;
                this.$http.GroupReport.getCourseChildUserList(params).then(res => {
                    this.tableRelevant.tableDataSource = res.data.items;
                    this.tableRelevant.tablePagination.total = res.data.totalCount;
                    res.data.items.forEach(v => {
                        if (v.isSelect && !this.tableSelected.selectedRowKeys.includes(JSON.stringify(v))) {
                            this.tableSelected.selectedRowKeys.push(JSON.stringify(v))
                        }
                    })
                }).finally(() => {})
            },

            //获取年级列表
            getGradeList() {
                this.$http.CommonInterface.getGradeClass({
                    organizationId: this.nowCourseInfo.reportCourse.organizationId
                }).then(res => {
                    this.gradeList = res.data;
                })
            },
            //获取年级列表
            getClassList(id) {
                this.searchForm.classId = undefined;
                try {
                    this.classList = this.gradeList.filter(f => f.id === id)[0].children;
                } catch (e) {
                    console.log(e);
                }
            },

            //重置
            searchReset() {
                this.searchForm = {
                    gradeId: undefined,
                    classId: undefined,
                    userName: ""
                };
                this.classList = []
                this.getPageList(1);
            },
        }
    }
</script>

<style scoped>
    .serach-item {
        width: 180px;
        margin-bottom: 15px;
    }
</style>
